// src/icons/svgs/tooltip-remove.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var SvgTooltipRemove = (props, ref) => /* @__PURE__ */ jsxs("svg", { fill: "none", viewBox: "0 0 28 28", ref, ...props, children: [
  /* @__PURE__ */ jsx("path", { fill: "#343A40", fillRule: "evenodd", d: "M26.218 19.996a.78.78 0 0 0-1.103-1.103l-2.56 2.56-2.559-2.56a.78.78 0 0 0-1.103 1.103l2.56 2.56-2.56 2.56a.78.78 0 0 0 1.103 1.102l2.56-2.56 2.56 2.56a.78.78 0 0 0 1.102-1.103l-2.56-2.56z", clipRule: "evenodd" }),
  /* @__PURE__ */ jsx("path", { stroke: "#343A40", strokeLinecap: "round", strokeWidth: 1.56, d: "M24.639 16.333c.164-.751.25-1.532.25-2.333C24.89 7.986 20.014 3.111 14 3.111S3.111 7.986 3.111 14s4.875 10.889 10.89 10.889c.8 0 1.58-.087 2.333-.25" }),
  /* @__PURE__ */ jsx("path", { stroke: "#343A40", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.56, d: "M14.004 18.666v-5.444" }),
  /* @__PURE__ */ jsx("path", { fill: "#343A40", d: "M15.17 9.723a1.166 1.166 0 1 0-2.332.001 1.166 1.166 0 0 0 2.332-.001" })
] });
var ForwardRef = forwardRef(SvgTooltipRemove);
var tooltip_remove_default = ForwardRef;
export {
  tooltip_remove_default as TooltipRemove
};
